import { render, staticRenderFns } from "./CustomerProfileModal.vue?vue&type=template&id=0b500d57&scoped=true"
import script from "./CustomerProfileModal.vue?vue&type=script&lang=js"
export * from "./CustomerProfileModal.vue?vue&type=script&lang=js"
import style0 from "./CustomerProfileModal.vue?vue&type=style&index=0&id=0b500d57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b500d57",
  null
  
)

export default component.exports